import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class RepairAgentActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    let result = false;

    if (!ProtectedEntitiesHelper.isComputer(record)) {
      result = true;
    }

    if (ProtectedEntitiesHelper.isUnifiedClient(record)) {
      if (ProtectedEntitiesHelper.isWindowsOs(record) || ProtectedEntitiesHelper.isNixOs(record)) {
        result = true;
      }
    }

    if (record.specifics.serverHasNsxIntegration) {
      return false;
    }

    if (ProtectedEntitiesHelper.isComputer(record) && !ProtectedEntitiesHelper.isManaged(record)) {
      return false;
    }

    if (
      ProtectedEntitiesHelper.isSandboxAnalyzer(record) ||
      ProtectedEntitiesHelper.isGhostr(record) ||
      ProtectedEntitiesHelper.isNsva(record)
    ) {
      return false;
    }

    if (ProtectedEntitiesHelper.isProtectedBySecurityContainer(record)) {
      return false;
    }

    return result;
  }
}
